import ShapeElementMetaData from './ShapeElementMetaData';
import {getBorderRadiusSetter} from 'crazyEditor/core/elements/utils/commonElementMethods';
import * as Colors from 'material-ui/styles/colors';

const presets = [
  {
    type: ShapeElementMetaData.type,
    layout: {
      x: 0,
      y: 0,
      width: 100,
      height: 100
    },
    compProps: {
      backgroundColor: Colors.lightBlue500,
      zIndex: 1,
      ...getBorderRadiusSetter('5px').compProps
    },
    data: {},
    hidden: false
  }
];

export default presets;
